import { render, staticRenderFns } from "./PolicyExpiry.vue?vue&type=template&id=2da2158b&scoped=true"
import script from "./PolicyExpiry.vue?vue&type=script&lang=js"
export * from "./PolicyExpiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da2158b",
  null
  
)

export default component.exports